import { render, staticRenderFns } from "./BeneficiaryViewModal.vue?vue&type=template&id=562256b4&"
import script from "./BeneficiaryViewModal.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports